import React, { Suspense } from 'react'

const HomePageBase = React.lazy(() => import('./Home'))

export const HomePage = () => (
  <Suspense fallback={null}>
    <HomePageBase />
  </Suspense>
)
